import { createContext } from 'react'

export interface ActiveChatContextValue {
  activeChatNodeId: string | null
  openChat: (nodeId: string) => void
  closeChat: () => void
}

export const ActiveChatContext = createContext<ActiveChatContextValue | null>(null)
